import styled from 'styled-components'

export const LoadingWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  z-index: 99;
  user-select: none;

  #lottie {
    position: fixed;
    bottom: 50vh;
    width: 150px;
    height: 150px;
    will-change: transform, contents;
    transform: translateZ(0);
  }

  .content {
    position: fixed;
    bottom: 38vh;
    font-size: 16px;
    text-align: center;
    letter-spacing: 0.2px;
    line-height: 28px;
    font-family: ${({ theme }) => theme.font.light};
    animation: simple-fade-in 0.8s ease-in;

    p {
      margin: 12px 0;
    }
  }

  .hidden {
    display: none;
  }

  .progress-bar {
    height: 2px;
    width: 100%;
    max-width: 80vw;
    background: #c9c9c9;
    position: relative;
    margin-top: 12px;

    &::before {
      content: '';
    }

    .progress,
    &::before {
      background: #000;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 0;
    }

    .progress {
      animation: loading 15s forwards;
    }

    &.completed {
      &::before {
        animation: completeLoading 0.8s forwards;
      }
    }
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.lg}) {
    .content {
      bottom: 42vh;
      font-size: 22px;
      line-height: 34px;
    }

    #lottie {
      width: 150px;
      height: 150px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    .content {
      bottom: 10vh;
      line-height: 34px;
    }

    #lottie {
      bottom: 42vh;
      width: 120px;
      height: 120px;
    }
  }

  @keyframes loading {
    0% {
      width: 0;
    }
    20% {
      width: 20%;
    }
    40% {
      width: 40%;
    }
    60% {
      width: 60%;
    }
    75% {
      width: 75%;
    }
    100% {
      width: 95%;
    }
  }

  @keyframes completeLoading {
    0% {
      width: 85%;
    }
    100% {
      width: 100%;
    }
  }
`
